var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarIcon = function SvgStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.4 4.8 1.5 4.71h4.683c.403.005.57.543.247.796l-3.802 2.932 1.44 4.687c.12.404-.317.736-.646.492L11 15.502l-3.822 2.914c-.328.244-.765-.088-.645-.491l1.466-4.687-3.829-2.933c-.323-.252-.156-.79.247-.795h4.686L10.6 4.8c.13-.4.67-.4.798 0",
    clipRule: "evenodd"
  })));
};
export default SvgStarIcon;